import { useCallback, useEffect } from 'react';
import { some } from 'lodash';

const useClickOutside = (refs, onClickOutside) => {
  const handleDocumentClick = useCallback(
    e => {
      if (some(refs, ref => ref?.current?.contains(e.target))) return;

      setTimeout(() => onClickOutside());
    },
    [onClickOutside, refs]
  );

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, true);

    return () =>
      document.removeEventListener('click', handleDocumentClick, true);
  }, [handleDocumentClick]);
};

export default useClickOutside;
